/** Formatea un peso en kg con máximo 2 decimales */
export function formatKg(value: number): string {
  return new Intl.NumberFormat("es-CO", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(value);
}

/** Formatea un valor monetario en COP sin decimales */
export function formatCop(value: number): string {
  return new Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(value);
}

/** Formatea un número entero (animales, días, etc.) */
export function formatInt(value: number): string {
  return Math.round(value).toLocaleString("es-CO");
}

/** Proyecta el peso estimado total del lote a la fecha actual usando la ganancia diaria.
 *  Fórmula servidor: pesoEstimado(t) = ganaderiaPesoEstimado + ganaderiaGananciaDiariaKg × (t − ganaderiaFechaUltimoPesoEstimado)
 *  Retorna el valor sin redondear; aplicar formatKg() al mostrar. */
export function projectPesoEstimado(lote: {
  ganaderiaPesoEstimado: number | null;
  ganaderiaFechaUltimoPesoEstimado: string | null;
  ganaderiaGananciaDiariaKg: number | null;
}): number {
  const { ganaderiaPesoEstimado, ganaderiaFechaUltimoPesoEstimado, ganaderiaGananciaDiariaKg } = lote;
  if (ganaderiaPesoEstimado == null || ganaderiaPesoEstimado <= 0) return 0;
  if (!ganaderiaFechaUltimoPesoEstimado || ganaderiaGananciaDiariaKg == null || ganaderiaGananciaDiariaKg <= 0)
    return ganaderiaPesoEstimado;
  const dias = Math.floor((Date.now() - new Date(ganaderiaFechaUltimoPesoEstimado).getTime()) / 86_400_000);
  if (dias <= 0) return ganaderiaPesoEstimado;
  return ganaderiaPesoEstimado + (ganaderiaGananciaDiariaKg * dias);
}
